module.exports = __webpack_public_path__ + "img/weizhibo_orange.76a23899.png";